import React, { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Modal } from "antd";
import { assignMessage, convertRoundNumber, errorMessage, successMessage } from '../../../utils/helpers'
import { ADMIN } from '../../../utils/apis'
import axios from "axios";
import { currencySign } from "../../../utils/constants";

const ServiceFeeForSentDollerMatchRequest = (props) => {
    const { user, language, selectedLanguage } = props
    const [visible, setVisible] = useState(false)
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [dollerMatchFee, setDollerMatchFee] = useState(null)

    const getDollerMatchFee = () => {
        axios.get(ADMIN?.GET_SEND_DOLLER_MATCH_REQ_FEE)
            .then((res) => {
                const { data } = res
                setDollerMatchFee(data?.data?.[0] || [])
            })
            .catch((e) => {
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }


    const onFinish = (values) => {
        values.adminId = user?._id
        dollerMatchFee?.money && (values._id = dollerMatchFee?._id)
        axios.post(dollerMatchFee?._id ? ADMIN?.EDIT_SEND_DOLLER_MATCH_REQ_FEE : ADMIN?.ADD_SEND_DOLLER_MATCH_REQ_FEE, values)
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    successMessage(assignMessage(data?.message, language?.language))
                    getDollerMatchFee()
                }
            })
            .catch((e) => {
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }

    useEffect(() => {
        getDollerMatchFee()
    }, [])

    const handleOk = () => {
        setVisible(false)
    }


    return (
        <>
            <div className="reward-point-box">
                <p className="p-none-margin-bolder-p">{selectedLanguage?.text_playerneedToPayServiceFeeForMatchRequestThatYouSethere}</p>
                <p className="p-none-margin-bolder-p">
                    {selectedLanguage?.text_playercanpay} ( {dollerMatchFee?.money ? `${currencySign} ${convertRoundNumber(dollerMatchFee?.money)}` : '---'} ) {selectedLanguage?.text_forMatchRequestAsServiceFee}</p>
                <div style={{ marginTop: '20px' }} className='button-div-flex-end'>
                    <Button
                        type="primary"
                        onClick={() => { setVisible(true) }} > {selectedLanguage?.text_UpdateMatchRequestFee}</Button>
                </div>
            </div>
            {/* --------Modal----- */}

            <Modal
                open={visible}
                onOk={handleOk}
                onCancel={handleOk}
                className='pop-info-modal'
                footer={null}>
                <div style={{ marginTop: '10px' }}>
                    <p className='p-question'>{selectedLanguage?.text_UpdateMatchRequestFee}</p>
                    <div style={{ display: 'flex', flexDirection: 'column' }} className='form-div-in-modal'>
                        <Form
                            name='form'
                            form={form}
                            onFinish={onFinish}
                            layout={'vertical'}
                        >
                            <div className='form-two-input-flex-inner-input newInpuHeightFull' style={{ width: '100%' }}>
                                <Form.Item
                                    name='money'
                                    initialValue={dollerMatchFee?.money}
                                    hasFeedback
                                    label={<p className='p-admin-title-text'>{selectedLanguage?.text_matchRequestFee}</p>}
                                    rules={[
                                        {
                                            required: true,
                                            message: selectedLanguage?.text_matchRequestFee
                                        }
                                    ]}
                                >
                                    <Input
                                        // Number
                                        step={0.5}    // Set the step to 0.01 for two decimal places
                                        precision={2}
                                        type='number'
                                        style={{ width: '100%' }}
                                        className='form-input-new-design-big-slam'
                                        prefix={<p style={{ color: 'white', margin: '0px' }}>{currencySign}</p>}
                                        placeholder={selectedLanguage?.text_matchRequestFee}
                                    />
                                </Form.Item>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', height: '40px', paddingRight: '5px' }}>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType='submit'
                                        loading={loading}
                                    >
                                        {dollerMatchFee?.money ? selectedLanguage?.text_UpdatePointSetting : selectedLanguage?.text_AddPointSetting}
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </div>
                </div >
            </Modal >
        </>
    )
}



export default ServiceFeeForSentDollerMatchRequest